<template>
<div v-role="'func'">
   <br>
<div>
  <v-card
    class="mx-auto"
    max-width="800"
  >
    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="headline"><v-icon color="green">crop_rotate</v-icon> Solicitação de Transferência</v-list-item-title>
        <v-list-item-subtitle>Efectue a transferência de um estudante aqui</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>

      <v-row align="center">
        <v-col cols="8">
          <h3>Filtragem dos estudante_dados</h3>
          <hr>
        </v-col>
        <v-col cols="4">
        </v-col>
      </v-row>
      <v-row>

          <v-col cols="4">

            <v-text-field
            v-model="matricula"
            label="Número de Matricula"
          ></v-text-field>

         </v-col>
          <v-col cols="4">

             <v-select
          item-value="idinstituicao"
          item-text="descricao"
          :disabled="matricula === ''"
          :items="instituicao"
          :rules="ruleRequired"
          @change="VerificaEstudante()"
          label="Instituição destino"
        ></v-select>

         </v-col>
          <v-col cols="4">
              <v-progress-circular
              v-if="progresso"
              indeterminate
              color="green"
          ></v-progress-circular>
            <label v-if="progresso">Verificando o estudante...</label>
            <strong v-if="msg" style="color:red">Estudante inexistente</strong>
         </v-col>

      </v-row>

      <v-row>
             <v-col cols="6">

            <v-text-field
            v-model="curso"
            label="Curso"
            :disabled="true"
          ></v-text-field>

         </v-col>

          <v-col cols="6">

               <v-btn color="blue" :disabled="!estudante_dados.length|| matricula === ''" style="color:white">Solicitar</v-btn>

         </v-col>

      </v-row>
    </v-card-text>

  </v-card>
</div>
</div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({

    instituicao: [],
    progresso: false,
    matricula: '',
    msg: false,
    curso: '',
    estudante_dados: [],
    disabilita: true,
    funcionarios: [],
    select_anolectivo: null,
    idMatricula: null,
    estudante: true,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    ruleRequired: [value => value || 'campo obrigatorio']

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select

    this.initializeInstituicao()
  },
  methods: {

    async initializeInstituicao () {
      try {
        this.instituicao = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.instituicao = this.instituicao.filter(t => t.descricao !== ls.get('instituicaodescricao'))
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    VerificaEstudante () {
      this.curso = ''
      this.Pesquisar()
    },

    async  Pesquisar () {
      try {
        this.progresso = true
        this.estudante_dados = await axios
          .get('/PesquisaGlobal2/' + this.matricula)
          .then(res => res.data)
        this.progresso = false
        this.curso = this.estudante_dados[0].descricao_curso
      } catch (error) {
        this.progresso = false
      }
    }

  }

}

</script>
